import { ContractorStatus, ContractorType, SubcontractorHeaderTypes } from './enums'

export const contractorStatusTitles = {
  [ContractorStatus.Active]: 'Active',
  [ContractorStatus.Deactivated]: 'Deactivated',
  [ContractorStatus.ExpiresSoon]: 'Expires Soon',
  [ContractorStatus.Unknown]: 'Unknown',
}

export const SPECIAL_HEADER_TYPES = [
  SubcontractorHeaderTypes.ALL,
  SubcontractorHeaderTypes.OWN,
  SubcontractorHeaderTypes.SUBCONTRACTOR,
]

export const contractorListHeaderTitles: Record<string, string> = {
  all: 'All contractors',
  own: 'Your contractors',
  subcontractor: "All MC's contractors",
}

export const contractorTypeTitles = {
  [ContractorType.Master]: 'Master',
  [ContractorType.Sub]: 'Sub',
  [ContractorType.IC]: 'IC',
}
